<template>
  <div class="upgrade-notification-content">
    <slot name="title">
      {{ title }}.
    </slot>
    <a @click="upgrade">Upgrade your account</a>
    to {{ intent }}.
  </div>
</template>

<script>
export default {
  name: 'UpgradeNotificationContent',
  props: {
    title: {
      type: String,
      default: 'This is a preview of a premium feature'
    },
    intent: {
      type: String,
      required: true
    }
  },
  methods: {
    upgrade () {
      this.$emit('upgrade')
    }
  }
}
</script>

<style scoped lang="scss">
.upgrade-notification-content {
  font-size: .9rem;

  a:hover {
    color: #000
  }
}
</style>
